module.exports = __webpack_public_path__ + "static/img/Proptech2022.b3f88bd5.png";